import { ChangeEvent, useEffect, useState } from 'react';
import { OnSelectChange } from '@ui/src';
import { AffilatedCompanyFormValues } from '../../../../hoc/new-application/types';

const useAffiliatedCompany = ({
  affilatedCompaniesValues,
  affilatedCompany,
  setAffilatedCompaniesValues,
}: {
  affilatedCompaniesValues?: AffilatedCompanyFormValues[];
  affilatedCompany?: AffilatedCompanyFormValues;
  setAffilatedCompaniesValues: (data: AffilatedCompanyFormValues[]) => void;
}) => {
  const [expanded, setExpanded] = useState(true);
  const [formValues, setFormValues] = useState<AffilatedCompanyFormValues>();

  const onChange = (e: ChangeEvent<HTMLInputElement> | OnSelectChange) => {
    const nextFormValues = { ...formValues };

    const { name, value } = e.target;

    const nextValues = affilatedCompaniesValues?.map((item) => {
      const result = { ...item };

      if (result.id === affilatedCompany?.id) {
        if (name === `name-${affilatedCompany?.id}`) {
          nextFormValues.name = value as string;
          result.name = value as string;
        } else if (name === `registrationNumber-${affilatedCompany?.id}`) {
          nextFormValues.registrationNumber = value as string;
          result.registrationNumber = value as string;
        } else if (name === `mainActivities-${affilatedCompany?.id}`) {
          nextFormValues.mainActivities = value as string;
          result.mainActivities = value as string;
        } else if (name === `position-${affilatedCompany?.id}`) {
          nextFormValues.position = value as string;
          result.position = value as string;
        } else if (name === `countryId-${affilatedCompany?.id}`) {
          nextFormValues.countryId = value as string;
          result.countryId = value as string;
        } else if (name === `percentageOfOwnership-${affilatedCompany?.id}`) {
          nextFormValues.percentageOfOwnership = value as string;
          result.percentageOfOwnership = value as string;
        }
      }

      return result;
    });

    setFormValues(nextFormValues as AffilatedCompanyFormValues);
    setAffilatedCompaniesValues(nextValues as AffilatedCompanyFormValues[]);
  };

  useEffect(() => {
    if (affilatedCompany) {
      setFormValues(affilatedCompany);
    }
  }, [affilatedCompany]);

  return {
    expanded,
    setExpanded,
    formValues,
    onChange,
  };
};

export default useAffiliatedCompany;
